import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/caller';

export const useHotelReviews = (id: number) => {
  const { data: hotelReviews } = useQuery(
    ['getHotelReviews', id],
    () =>
      callService(
        'HotelsService',
        'getReviews',

        {
          id: id,
        }
      ),
    {
      enabled: Boolean(id),
    }
  );
  return { hotelReviews };
};
